import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { getRandomPositions } from './utils/horizon-genesys-call-log.utils';

@Component({
  selector: 'horizon-otp-input',
  templateUrl: './horizon-otp-input.component.html',
  styleUrls: ['./horizon-otp-input.component.scss'],
})
export class HorizonOtpInputComponent implements OnInit {
  //#region Inputs
  @Input() otpValue: string = '';
  @Input() otpLength: number = 0;
  @Input() isDisabled: boolean = false;
  @Input() maxAttempts: number = 2;
  //#endregion

  //#region Outputs
  @Output() valueChanged = new EventEmitter<string>();
  @Output() isValid = new EventEmitter<boolean>();
  @Output() maxAttemptsReached = new EventEmitter<void>();
  //#endregion

  //#region Public properties
  referencePositions: { position: number; value: string }[] = [];
  otpInput: string[] = [];
  attemptsCount: number = 0;
  //#endregion

  //#region Lifecycle hooks
  ngOnInit(): void {
    this.referencePositions = getRandomPositions(this.otpValue, this.otpLength);
    this.otpInput = new Array(this.otpLength).fill('');
  }

  //#endregion

  //#region Public methods
  isInputInvalid(index: number, referencePosition: number): string {
    const hasEmptyValue = this.otpInput.some((value) => value === '');

    const isValid = this.referencePositions.find(
      (ref) =>
        ref.position === referencePosition && ref.value === this.otpInput[index]
    );

    return hasEmptyValue ? '' : isValid ? 'valid' : 'invalid';
  }

  onInputChange(index: number, event: any): void {
    const hasEmptyValue = this.otpInput.some((value) => value === '');
    if (!hasEmptyValue) this.attemptsCount++;

    const value = event.target.value;

    this.handleInputNavigation(index, value);
    this.otpInput[index] = value;
    const combinedValue = this.otpInput.join('');
    this.valueChanged.emit(combinedValue);

    this.checkAndValidateOtp();
  }

  //#region Private methods
  private handleInputNavigation(index: number, value: string): void {
    if (value.length === 1 && index < this.otpLength - 1) {
      const nextInput = document.querySelector(
        `input[data-index="${index + 1}"]`
      ) as HTMLInputElement;
      if (nextInput) nextInput.focus();
    }
  }

  private checkAndValidateOtp(): void {
    if (this.otpInput.every((val) => val !== '')) {
      this.validateOtp();
    }
  }

  private validateOtp(): void {
    const isValid = this.isOtpValid();
    this.isValid.emit(isValid);

    if (!isValid && this.attemptsCount >= this.maxAttempts) {
      this.isDisabled = true;
      this.maxAttemptsReached.emit();
    }
  }

  private isOtpValid(): boolean {
    const matches = this.referencePositions.map((ref, index) => {
      return ref.value === this.otpInput[index];
    });
    return matches.findIndex((_) => _ === false) >= 0 ? false : true;
  }

  //#endregion
}
